export default function Select() {
  return {
    MuiSelect: {
      styleOverrides: {
        root: {
          height: '100%',
        },
        icon: {
          right: '24px',
        },
        select: {
          backgroundColor: 'transparent',
          '&.Mui-disabled': {
            cursor: 'not-allowed',
            pointerEvents: 'all !important',
          },
        },
      },
    },
  };
}
